import { AxiosError } from 'axios'
import { TFunction } from 'react-i18next'

import { addError } from '../../../Common/ErrorHandling/store'
import { AppDispatch } from '../../../store'

export const handelFormError = (
  errorTitle: string,
  error: Error | null,
  t: TFunction,
  dispatch: AppDispatch,
) => {
  if (error instanceof AxiosError && error.response && error.response.data) {
    if (error.response.data.status === 'error' && error.response.data.message) {
      dispatch(
        addError({
          type: 'error',
          title: t(errorTitle),
          description: t(error.response.data.message),
          icon: 'info-circle',
          duration: 'long',
        }),
      )
      return
    }

    if (error.response.data.errors) {
      if (error.response.data.errors[0]) {
        dispatch(
          addError({
            type: 'error',
            title: t(errorTitle),
            description: t(error.response.data.errors[0]),
            icon: 'info-circle',
            duration: 'long',
          }),
        )
        return
      }

      for (const [key, list] of Object.entries(error.response.data.errors)) {
        const errorList = list as string[]
        errorList.forEach(errorString => {
          dispatch(
            addError({
              type: 'error',
              title: t(errorTitle),
              description: t(errorString),
              icon: 'info-circle',
              duration: 'long',
            }),
          )
        })
      }
      return
    }
  }
}
